namespace GeniuzPOS.Administration {
    export interface PsFuncKbMapShiftCodeForm {
        KbMapShiftCode: Serenity.IntegerEditor;
        KbMapShiftName: Serenity.StringEditor;
    }

    export class PsFuncKbMapShiftCodeForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsFuncKbMapShiftCode';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsFuncKbMapShiftCodeForm.init)  {
                PsFuncKbMapShiftCodeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PsFuncKbMapShiftCodeForm, [
                    'KbMapShiftCode', w0,
                    'KbMapShiftName', w1
                ]);
            }
        }
    }
}
